// extracted by mini-css-extract-plugin
module.exports = {"card":"cardQuizz_card__JStmq"};